const defaultResult = {
	scores: {},
	recommendations: {}
};

export default {
	namespaced: true,
	state: {
		results: defaultResult,
		loading: false,
		error: undefined
	},
	mutations: {
		setSuccess(state, payload) {
			state.results = payload;
			state.error = undefined;
			state.loading = false;
		},
		setLoading(state) {
			state.results = defaultResult;
			state.error = undefined;
			state.loading = true;
		},
		setError(state, payload) {
			state.results = defaultResult;
			state.error = payload;
			state.loading = true;
		}
	},
	actions: {
		async fetchData({ commit }, payload) {
			commit("setLoading");
			try {
				const http = await fetch(`${process.env.API}/results/${payload}`);
				if (!http.ok) {
					throw new Error(`Http error ${http.status}`);
				}
				const json = await http.json();
				commit("setSuccess", json);
			} catch (e) {
				commit("setError", e);
			}
		}
	},
	getters: {
		results(state) {
			return state.results;
		}
	}
};
